import loadable from '@loadable/component';

export const ReactQueryDevtoolsLoadable = loadable.lib(
  () => import('@tanstack/react-query-devtools/build/lib/index.prod.js'),
  { ssr: false },
);
